const calcRem = (size) => `${size / 16}rem`;

const margins = {
    small: calcRem(8),
    base: calcRem(10),
    lg: calcRem(12),
    xl: calcRem(14),
    xxl: calcRem(16),
    xxxl: calcRem(18),
};

const paddings = {
    small: calcRem(8),
    base: calcRem(10),
    lg: calcRem(12),
    xl: calcRem(14),
    xxl: calcRem(16),
    xxxl: calcRem(18),
};

const fonts = {
    family: {
        base: "Noto Sans KR, sans-serif",
        bold: "NotoSansBold, sans-serif",
        title: `'Merriweather', serif`,
    },
    size: {
        small: calcRem(14),
        base: calcRem(16),
        lg: calcRem(18),
        xl: calcRem(20),
        xxl: calcRem(22),
        xxxl: calcRem(25),
        titleSize: calcRem(50),
    },
    weight: {
        light: 100,
        regular: 400,
        medium: 500,
        bold: 700,
    },
};

const colors = {
    black: "#000000",
    black_2: "#223F49",
    white: "#FFFFFF",
    gray_1: "#222222",
    gray_2: "#767676",
    green_1: "#3cb46e",
    blue_1: "#00B9E1",
    blue_2: "#223F49",
    blue_3: "#22455C",
    blue_4: "#2685CA"
};

const interval = {
    base: calcRem(50),
    lg: calcRem(100),
    xl: calcRem(150),
    xxl: calcRem(200),
};

const verticalInterval = {
    base: `${calcRem(10)} 0 ${calcRem(10)} 0`,
};

const deviceSizes = {
    mobileS: "320px",
    mobileM: "375px",
    mobileL: "450px",
    tablet: "768px",
    tabletM: "806px",
    tabletL: "1024px",
};
// 미디어 쿼리의 중복 코드를 줄이기위해 정의된 변수입니다
const device = {
    mobileS: `only screen and (min-width: ${deviceSizes.mobileS})`,
    mobileM: `only screen and (min-width: ${deviceSizes.mobileM})`,
    mobileL: `only screen and (min-width: ${deviceSizes.mobileL})`,
    tablet: `(min-width: ${deviceSizes.tablet})`,
    tabletM: `(min-width: ${deviceSizes.tabletM})`,
    tabletL: `(min-width: ${deviceSizes.tabletL})`,
};


//테마에 따라 다른 값을 갖는 색상 값입니다 
const lightThemeColors = {
    ...colors,
    primary: "#333",
    secondary: "#fff",
    tertiary: "#808080",
};

const darkThemeColors = {
    ...colors,
    primary: "#fff",
    secondary: "#333",
    tertiary: "#d4d0c4",
};

// 테마와 관련없이 공통으로 사용되는 변수들입니다
const defalutTheme = {
    colors,
    deviceSizes,
    device,
    margins,
    paddings,
    fonts,
    interval,
    verticalInterval,
};

// 각 테마는 공통 변수와 함께, 각기 다른 색상 값들을 갖습니다.
export const darkTheme = {
    ...defalutTheme,
    colors: darkThemeColors,
};

export const lightTheme = {
    ...defalutTheme,
    colors: lightThemeColors,
};

